<template>
  <div v-if="progress.active" class="vue-progress-bar" :style="barStyle" />
</template>

<script>
import { progressState } from '@/plugins/progress'

export default {
  name: 'VueProgressBar',
  computed: {
    progress () {
      return progressState
    },
    barStyle () {
      return {
        position: 'fixed',
        top: 0,
        left: 0,
        height: this.progress.height,
        width: `${this.progress.percent}%`,
        backgroundColor: this.progress.color,
        zIndex: 99999,
        transition: 'width 0.2s ease'
      }
    }
  }
}
</script>
